export const SlaType = {
    STANDARD: "Standard",
    CUSTOM: "Custom",
};

export const turnaroundOptions = [
    { text: "5", value: 5 },
    { text: "7", value: 7 },
    { text: "10", value: 10 },
    { text: "15", value: 15 },
];

export const physicalPeoriaAndVMPTurnaroundOptions = [
    { text: "5", value: 5 },
    { text: "10", value: 10 },
    { text: "15", value: 15 },
];
